import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { Seo } from "@/components/Seo";

// NOTE: items in [BRACKETS] are placeholders the owner must complete before launch.

const COOKIE_ROWS = [
  ["Strictly necessary", "Site function, hosting, security", "Emergent (hosting)", "Always active — the site cannot work without these. They do not track you."],
  ["Preferences", "Your cookie-consent choice itself", "This website (stored on your device)", "Always active — it's what remembers that you already answered the cookie question."],
  ["Analytics", "None installed", "—", "Not in use. If analytics are ever added, they will stay off until you accept them here."],
  ["Advertising", "None installed", "—", "Not in use. No advertising pixels, tags or conversion trackers are present on this website."],
];

const SECTIONS = [
  {
    h: "What this site actually uses",
    p: [
      "The short version: this website sets no tracking cookies. The only thing stored on your device is your own cookie-consent choice, so you're not asked on every visit.",
      "The table below lists every category, its real status, and who sets it — verified against the actual code of this site, not a template.",
    ],
  },
  {
    h: "The embedded Check-Up portal",
    p: [
      "The Check-Up form runs inside an embedded application hosted by Lovable. That application may set its own cookies or storage within its frame to operate the form. Those are governed by Lovable's own policies — they only load when you visit the Check-Up page.",
    ],
  },
  {
    h: "Third-party links",
    p: [
      "Links to Instagram, WhatsApp, X, LinkedIn, the Zoho booking calendar and Stripe checkout open those services in their own pages or tabs. Once you leave this site, their cookies and policies apply.",
    ],
  },
  {
    h: "Change your choice anytime",
    p: [
      "Use the Cookie Settings link in the footer of any page to review, change or withdraw your consent. Rejecting optional cookies never blocks any part of this website — there is nothing here that depends on them.",
    ],
  },
];

export default function Cookies() {
  return (
    <div data-testid="cookies-page">
      <Seo
        title="Cookie Policy | The AI Doctor"
        description="What cookies theaidoctor.website actually uses: no advertising or analytics trackers — only strictly necessary storage and your consent choice."
      />
      <PageHero
        eyebrow="Cookie Policy"
        title="No trackers. Here's the proof, category by category."
        intro="This site currently installs no analytics and no advertising cookies. What little is stored is listed below."
      />
      <section className="shell pb-16 max-w-5xl">
        <Reveal className="border-t border-white/10">
          {COOKIE_ROWS.map(([cat, purpose, setter, note]) => (
            <div key={cat} className="grid grid-cols-1 lg:grid-cols-[220px_1fr_220px_1fr] gap-3 lg:gap-8 py-7 border-b border-white/10">
              <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-[#5CCBF5]">{cat}</p>
              <p className="text-[#a7a7a2] leading-relaxed">{purpose}</p>
              <p className="text-[#a7a7a2] leading-relaxed">{setter}</p>
              <p className="text-[#a7a7a2] leading-relaxed">{note}</p>
            </div>
          ))}
        </Reveal>
      </section>
      <section className="shell pb-28 lg:pb-40 max-w-3xl">
        <div className="border-t border-white/10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.04} className="py-10 border-b border-white/10">
              <h2 className="display text-2xl text-[#f5f3ee]">{s.h}</h2>
              {s.p.map((para, j) => (
                <p key={j} className="mt-4 text-[#a7a7a2] text-lg leading-relaxed">{para}</p>
              ))}
            </Reveal>
          ))}
        </div>
        <p className="mt-10 font-mono text-[11px] tracking-[0.14em] uppercase text-[#5c5c58]">Policy version 2026-07 · Questions: info@theaidoctor.website</p>
      </section>
    </div>
  );
}
